import React from 'react';
import OptimizedImage from '../../components/common/OptimizedImage';

const Hero: React.FC = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('agendar');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="pt-24 pb-16 md:py-28 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0 md:pr-10">
            <h1 className="text-4xl md:text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-contessa-900 leading-tight mb-4">
              Acompañamiento en cada paso de tu 
              <span className="text-contessa-600"> maternidad</span>
            </h1>
            <p className="text-lg text-contessa-800 mb-8 max-w-lg">
              Te brindo apoyo profesional y humano durante el embarazo, 
              nacimiento y puerperio, para que vivas esta etapa con plenitud y seguridad.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <button 
                onClick={scrollToBooking}
                className="bg-contessa-600 hover:bg-contessa-700 text-white px-8 py-3 rounded-full transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1"
              >
                Agendá una consulta
              </button>
              <button 
                onClick={() => document.getElementById('servicios')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-transparent border-2 border-contessa-400 text-contessa-700 hover:bg-contessa-50 px-8 py-3 rounded-full transition-all duration-300"
              >
                Conocé mis servicios
              </button>
            </div>
          </div>
          <div className="md:w-1/2 relative transform hover:scale-105 transition-transform duration-500 mx-auto">
              <OptimizedImage 
                src="images/hero-2.jpg" 
                alt="Pancita emabrazada, junto con un tierno peluche y su corazon dibujado" 
                className="object-cover rounded-lg shadow-xl brightness-120"
                sizes="(max-width: 768px) 100vw, 50vw"
                priority={true}
              />
            <div className="absolute -bottom-5 -left-5 md:-left-1 bg-contessa-100 p-4 rounded-lg shadow-md transform rotate-3 hidden md:block ">
              <p className="text-contessa-800 font-medium italic">
                "El mejor cuidado para vos y tu bebé"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;